var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { formTextBackgroundStyles, useFormTextStateProps, } from '../../../context';
import { useAdornmentState } from '../context';
const StyledAdornmentButton = styled.button `
  ${({ $position, theme: { space } }) => `
    display: flex;
    align-items: center;
    border: none;
    border-top-${$position}-radius: 4px;
    padding: 0;
    padding-${$position}: ${space.xs};
    cursor: pointer;
  `}
  ${formTextBackgroundStyles}
`;
export const AdornmentButton = React.forwardRef((_a, ref) => {
    var { onClick, children } = _a, others = __rest(_a, ["onClick", "children"]);
    const formTextStateProps = useFormTextStateProps({});
    const { position } = useAdornmentState();
    return (React.createElement(StyledAdornmentButton, Object.assign({}, others, formTextStateProps, { "$position": position, onClick: onClick, disabled: formTextStateProps.$isDisabled, type: "button", ref: ref }), children));
});
//# sourceMappingURL=AdornmentButton.js.map